const domain = "http://localhost:3000";

export { domain };
